import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { echo } from '../../../../utilities/sockets';
import { getBranchOrderFromSockets } from '../../schemes/branch_order/actions';
import { getTreeOrderFromSockets } from '../../schemes/order/actions';
import { getServiceProductOrderFromSockets } from '../../schemes/service_product_order/actions';

const STORE_PRODUCT = 'App\\Models\\StoreProduct';
const TREE_PRODUCT = 'App\\Models\\Tree';
const SERVICE_PRODUCT = 'App\\Models\\ServiceProduct';

export const SocketPayment = ({ paymentIntent }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!paymentIntent || !paymentIntent.id) {
      return undefined;
    }

    const channelName = `order-payment-status.${paymentIntent.id}`;
    echo.leave(channelName);

    echo.private(channelName).listen('.order-payment.status', (event) => {
      if (event.status === 'success' && event.order) {
        const orderableType = event.order.orderable_type;
        if (orderableType === TREE_PRODUCT) {
          dispatch(getTreeOrderFromSockets(event));
        } else if (orderableType === SERVICE_PRODUCT) {
          dispatch(getServiceProductOrderFromSockets(event));
        } else if (orderableType === STORE_PRODUCT) {
          dispatch(getBranchOrderFromSockets(event));
        } else {
          console.warn('unk', orderableType);
        }
      }
    });

    // Función de limpieza: se ejecuta cuando el componente se desmonta
    return () => {
      echo.leave(channelName);
    };
  }, [paymentIntent, dispatch]);

  return null;
};
